module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("eulkD"))).then(() => parcelRequire('iDabs'));